import { Moment } from 'moment'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import Button from '../../../../App/Components/Button/Button'
import Spinner from '../../../../App/Components/Spinner/Spinner'
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../App/Hooks/reduxHooks'
import { ICustomer } from '../../../../Customer/interfaces/ICustomer'
import CustomerSearch from '../../../../Customer/Search/Search'
import { ICreateWaitingCustomer } from '../../interface/ICreateWaitingCustomer'
import { createWaitingCustomer } from '../../store/Actions'

import { DateSelect } from './Components/DateSelect/DateSelect'
import { WaitingItemDetails } from './Components/WaitingItemDetails/WaitingItemDetails'
import { IActivitySelect } from './interfaces/IActivitySelect'
import { IProps } from './IProps'

const Create = (props: IProps) => {
  const [customer, setCustomer] = useState<ICustomer | undefined>()
  const [hasDate, setHasDate] = useState<boolean>(undefined)
  const [date, setDate] = useState<Moment | undefined>(undefined)
  const [remark, setRemark] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [activitySelectObject, setActivitySelectObject] =
    useState<IActivitySelect>({
      type: 'idle',
      selectionDetails: null,
      activeSelection: null,
      menuId: null,
    })
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const { activityList, menuList } = useAppSelector(state => {
    return {
      menuList: state.calendar.waitingList.menuList,
      activityList: state.calendar.waitingList.activityList,
    }
  })

  const save = () => {
    if (activitySelectObject.type !== 'selected') {
      alert(t('select a service'))
      return
    }
    setIsSaving(true)
    const waitingCustomer: ICreateWaitingCustomer = {
      wanted_at: date ? date.clone().format('YYYY-MM-DD hh:mm:ss') : undefined,
      remark,
      customer: { uuid: customer.uuid },
      activities: activitySelectObject.menuId
        ? undefined
        : activitySelectObject.selectionDetails,
      menu_id: activitySelectObject.menuId
        ? activitySelectObject.menuId
        : undefined,
    }

    props.onSubmit(waitingCustomer)
    dispatch(createWaitingCustomer(waitingCustomer))
      .then(() => {
        let url = '/calendar/waiting-list'
        if (date) {
          url += `/${date.clone().format('YYYY-MM-DD')}/${date
            .clone()
            .format('YYYY-MM-DD')}`
        }
        history.push(url)
      })
      .catch(() => setIsSaving(false))
    setCustomer(undefined)
    setDate(undefined)
  }

  if (typeof menuList === 'undefined') {
    return <Spinner />
  }

  if (typeof activityList === 'undefined') {
    return <Spinner />
  }

  const getContent = () => {
    if (isSaving) {
      return <Spinner />
    }
    if (!customer) {
      return (
        <CustomerSearch
          onSelected={selectedCustomer => setCustomer(selectedCustomer)}
          onDeselected={() => setCustomer(undefined)}
        />
      )
    }

    if (typeof hasDate === 'undefined') {
      return (
        <DateSelect
          customer={customer}
          setCustomer={setCustomer}
          date={date}
          setDate={setDate}
          setHasDate={setHasDate}
        />
      )
    }

    if (typeof hasDate !== 'undefined') {
      return (
        <WaitingItemDetails
          customer={customer}
          setCustomer={setCustomer}
          date={date}
          setDate={setDate}
          menuList={menuList}
          activityList={activityList}
          setActivitySelectObject={setActivitySelectObject}
          activitySelectObject={activitySelectObject}
          setHasDate={setHasDate}
          save={save}
          remark={remark}
          setRemark={setRemark}
        />
      )
    }
  }
  return (
    <div className={'page-layout small'}>
      <h1>{t('Add to waiting list')}</h1>
      {getContent()}

      <Button
        type={'button'}
        buttonStyle={'dim'}
        onClick={() => history.push('/calendar/waiting-list')}>
        {t('Cancel')}
      </Button>
    </div>
  )
}

export default Create
